import * as React from "react";
import { NavigationMenu as BaseNavigationMenu } from "@base-ui-components/react/navigation-menu";
import {
  navigationMenuArrowClasses,
  navigationMenuPopupClasses,
  navigationMenuPositionerClasses,
  navigationMenuRootClasses,
  navigationMenuViewPortClasses,
} from "./NavigationMenu.style";
import ArrowSvg from "@/common/ArrowSvg";

type NavigationMenuProps = BaseNavigationMenu.Root.Props & {
  container?: BaseNavigationMenu.Portal.Props["container"];
};

function NavigationMenu(props: NavigationMenuProps) {
  const { container, children, ...rest } = props;
  return (
    <BaseNavigationMenu.Root className={navigationMenuRootClasses()} {...rest}>
      {children}

      <BaseNavigationMenu.Portal container={container}>
        <BaseNavigationMenu.Positioner
          // align="start"
          sideOffset={10}
          collisionPadding={{ top: 5, bottom: 5, left: 40, right: 40 }}
          // sticky
          className={navigationMenuPositionerClasses({})}
          style={{
            ["--duration" as string]: "0.35s",
            ["--easing" as string]: "cubic-bezier(0.22, 1, 0.36, 1)",
            // left: "0!important",
          }}
        >
          <BaseNavigationMenu.Popup className={navigationMenuPopupClasses()}>
            <BaseNavigationMenu.Arrow className={navigationMenuArrowClasses()}>
              <ArrowSvg />
            </BaseNavigationMenu.Arrow>
            <BaseNavigationMenu.Viewport
              className={navigationMenuViewPortClasses()}
            />
          </BaseNavigationMenu.Popup>
        </BaseNavigationMenu.Positioner>
      </BaseNavigationMenu.Portal>
    </BaseNavigationMenu.Root>
  );
}

export default NavigationMenu;
